/** Default height for e-sign document preview containers (list view, modal preview, etc.). */
export const ESIGN_DOCUMENT_DEFAULT_HEIGHT = "475px";
